// 한 판 오케스트레이션: 고백 → (로컬 위기 1차) → 달 응답(AI) → 실패면 에러면(★더미 편지 금지).
// 무흔적: confession.text는 여기서 프록시로만 흘러가고, 어디에도 저장하지 않는다.

import type { Confession, Lang, MoonError, MoonResponse } from "./types";
import { defaultMoon } from "./moonClient";
import { crisisResponse, errorResponse } from "./moon";
import { localCrisisTrigger } from "./crisis";

export interface RespondOptions {
  moon?: typeof defaultMoon;
}

// AI 호출 실패를 종류별로 분류 — 평문 에러 문구 라우팅용(위기와 별개).
function classifyError(e: unknown): MoonError {
  if (typeof navigator !== "undefined" && navigator.onLine === false) return "offline";
  if ((e as { name?: string })?.name === "AbortError") return "timeout"; // AbortController 타임아웃
  if (/\b429\b/.test(String((e as { message?: string })?.message ?? ""))) return "busy";
  return "unavailable";
}

export async function runMoon(
  confession: Confession,
  lang: Lang,
  opts: RespondOptions = {},
): Promise<MoonResponse> {
  // 1) 로컬 위기 1차 — 트리거되면 원문을 AI로 보내지 않고 곧장 안전면(빠름·프라이버시).
  if (localCrisisTrigger(confession.text)) return crisisResponse();

  // 2) AI 응답. 실패하면 ★예시 편지가 아니라 평문 에러면으로(재시도 유도).
  const moon = opts.moon ?? defaultMoon;
  const now = new Date();
  try {
    return await moon.respond({ lang, text: confession.text, now });
  } catch (e) {
    return errorResponse(classifyError(e));
  }
}
